import clsx from 'clsx'
import Image from 'next/image'
import React, { Fragment, useMemo } from 'react'

import s from './styles.module.scss'

import { IconSvg } from '../../atoms'
import { TagListItem } from '../../atoms/fields/Tag/tag-list-item/TagListItem'
import { HouseRankingEnum, TagOutputDto } from '../../../lib/graphql'

const houseRankLabel: { [key in HouseRankingEnum]: string } = {
  [HouseRankingEnum.TOP10]: 'Top 10 Naboo',
  [HouseRankingEnum.TOP20]: 'Top 20 Naboo',
  [HouseRankingEnum.TOP100]: 'Top 100 Naboo',
}

export const TagsList = ({
  tags,
  className,
  tagClassName,
  isNabooFavorite,
  isAvailableSoon,
  houseRanking,
  isExclusive = false,
}: {
  tags: Partial<TagOutputDto>[]
  className?: string
  tagClassName?: string
  isNabooFavorite?: boolean
  isAvailableSoon?: boolean
  houseRanking?: HouseRankingEnum | null
  isExclusive?: boolean
}) => {
  const tagsLabels = useMemo(() => {
    return tags?.map((tag) => tag.label) ?? []
  }, [tags])

  if (!tagsLabels.length) {
    return null
  }

  const renderTags = (className?: string) => (
    <div
      className={clsx(
        className,
        !isExclusive ? s.houseTagsAlternative : s.houseTags,
      )}
    >
      {houseRanking && (
        <TagListItem
          label={houseRankLabel[houseRanking]}
          className={
            className ? [className, s.tag, s.tagRanking] : s.tagRanking
          }
          icon={
            <IconSvg.Star
              color='var(--clr-primary-400)'
              style={{ marginTop: '1px' }}
            />
          }
        />
      )}
      {isNabooFavorite && (
        <TagListItem
          label='Notre coup de cœur'
          className={
            className
              ? [className, s.tag, s.tagNabooFavorite]
              : s.tagNabooFavorite
          }
          icon={<IconSvg.Thumb color='var(--clr-green)' />}
        />
      )}
      {isAvailableSoon && (
        <TagListItem
          label='Bientôt sur Naboo'
          className={className}
          icon={<IconSvg.Timelapse />}
        />
      )}
      {tagsLabels.map((tag, i) => (
        <Fragment key={`tag-${tag}-${i}`}>
          <TagListItem
            label={tag as string}
            className={className}
            icon={
              !isExclusive ? (
                <Image
                  src={tags[i].icon as string}
                  alt={tag as string}
                  width={12}
                  height={12}
                />
              ) : (
                <></>
              )
            }
          />
          <span>
            {i < tagsLabels.length - 1 && !isExclusive && className
              ? ' | '
              : ''}
          </span>
        </Fragment>
      ))}
    </div>
  )

  return (
    <div className={clsx(s.containerTags, className)} style={{ marginTop: 0 }}>
      {renderTags(tagClassName)}
      <div className={s.hoverContainer}>{renderTags()}</div>
    </div>
  )
}
